class VideoPlayer {
  constructor(items) {
    this.items = Array.from(items);

    this.togglePlayPause = this.togglePlayPause.bind(this);
    this.changeButtonType = this.changeButtonType.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
    this.seek = this.seek.bind(this);
    
    this.items.forEach(item => {
      let video = item.getElementsByClassName('js-media-video')[0];
      let btn = item.getElementsByClassName('js-play-pause-button')[0];
      let icon = btn.querySelector('img');
      let progressBar = item.getElementsByClassName('js-progress-bar')[0];
      let progressText = item.getElementsByClassName('js-progress-text')[0];
      let remainingTime = item.getElementsByClassName('js-remaining-time')[0];
  
      video.controls = false;

      video.addEventListener('timeupdate', () => {
        this.updateProgress(video, progressBar, remainingTime)
      });

      video.addEventListener('touchend', (e) => {
        e.preventDefault();
        this.togglePlayPause(btn, icon, video);
      });
      btn.addEventListener('touchend', (e) => {
        e.preventDefault();
        this.togglePlayPause(btn, icon, video);
      });
      
      video.addEventListener('click', () => {
        this.togglePlayPause(btn, icon, video);
      }, {passive: true});
      btn.addEventListener('click', () => {
        this.togglePlayPause(btn, icon, video);
      }, {passive: true});
      progressText.addEventListener('click', (e) => {
        this.seek(e, video, progressBar);
      }, {passive: true});
      
      // For firefox users who right click to control
      video.addEventListener('play', () => {
        this.changeButtonType(btn, icon, '/images/pause.svg', 'pause');
      }, false);

      // For firefox users who right click to control
      video.addEventListener('pause', () =>  {
        this.changeButtonType(btn, icon, '/images/right-arrow.svg', 'play');
      }, false);
    });
  }

  togglePlayPause(btn, icon, video) {
    if (video.paused || video.ended) {
      this.changeButtonType(btn, icon, '/images/pause.svg', 'pause');
      video.play();
    }
    else {
      this.changeButtonType(btn, icon, '/images/right-arrow.svg', 'play');
      video.pause();
    }
  }

  changeButtonType(btn, icon, iconSrc, value) {
    btn.title = value;
    icon.src = iconSrc;
 }

  updateProgress(video, progressBar, remainingTime) { 
    let timeLeft = video.duration - video.currentTime; 
    let minRemaining = parseInt(timeLeft / 60, 10);
    let secondsRemaining = String(Math.round(timeLeft % 60)).padStart(2,0);
    let displayTime = minRemaining + ':'+ secondsRemaining; 
    let percentage = Math.floor((100 / video.duration) * video.currentTime);

    if( !remainingTime ) {
      return;
    }
    
    remainingTime.innerText = displayTime;
    progressBar.value = percentage; 
  }

  seek(e, video, progressBar) {
    const padding = 16;

    let percent = (e.offsetX + padding) / progressBar.offsetWidth;
    video.currentTime = percent * video.duration;
    progressBar.value = percent / 100;
  }
}

new VideoPlayer(document.getElementsByClassName('js-media-player'));


// WEBPACK FOOTER //
// ./javascript/modules/videoPlayer.js